module.exports = __webpack_public_path__ + "img/profile_verified.92fbac85.svg";